<template>
  <div id="engagementActionPlan">
    <OverviewMain
      v-if="actionPlanOverview"
      :action-plans="fakeActionPlan"
      :action-plans-overview="actionPlanOverview"
      :engagement="engagement"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/api';
import OverviewMain from '@/views/dashboard/content/leader/actionPlan/overview/OverviewMain.vue';

export default {
  name: 'EngagementActionPlan',

  components: {
    OverviewMain,
  },

  data: () => ({
    loading: true,
    engagement: null,
    actionPlanOverview: null,
    // OverviewMain.vue require a action plan to check status and submitted
    fakeActionPlan: {
      status: 'published',
      submitted: true,
    },
  }),

  computed: {
    ...mapState({
      role_type: (state) => state.user.user.role_type,
    }),
  },

  created() {
    this.getEngagement();
    this.getEngagementActionPlan();
  },

  methods: {
    async getEngagement() {
      try {
        this.loading = true;
        const response = await api.getEngagement(this.$route.params.id);
        this.engagement = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async getEngagementActionPlan() {
      try {
        this.loading = true;
        const response = await api.getEngagementActionPlan(this.$route.params.id);
        this.actionPlanOverview = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
